import { FC, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'src/components';
import { isTextCutOff } from 'src/utils/isTextCutOff';
import { ROUTES } from 'src/constants/routes.const';
import { useHref } from 'src/hooks/useHref';
import * as S from './styles';
import { msgs } from './messages';

export { ImageWrapper as RecommendationCardImageWrapper } from './styles';

interface RecommendationCardProps {
  topicId: string | number;
  topicTitleSlug: string;
  scenarioId: number;
  title: string;
  titleSlug: string;
  iconUrl: string;
  numberOfLearnables: number;
  isInfluencer?: boolean;
  influencerName?: string;
}

export const RecommendationCard: FC<RecommendationCardProps> = ({
  topicId,
  topicTitleSlug,
  scenarioId,
  title,
  titleSlug,
  iconUrl,
  numberOfLearnables,
  isInfluencer,
  influencerName,
}) => {
  const intl = useIntl();
  const titleRef = useRef<HTMLHeadingElement>(null);

  const scenarioHref = useHref({
    pathname: ROUTES.scenario,
    query: {
      topicId,
      topicTitleSlug,
      scenarioId,
      scenarioTitleSlug: titleSlug,
    },
  });

  const immersiveScenarioHref = useHref({
    pathname: ROUTES.immersiveScenario,
    query: {
      topicId,
      topicTitleSlug,
      scenarioId,
      scenarioTitleSlug: titleSlug,
      accountUrl: influencerName || '',
    },
  });

  useEffect(() => {
    if (titleRef.current && isTextCutOff(titleRef.current)) {
      titleRef.current.setAttribute('title', title);
    }
  }, [title]);

  return (
    <Link
      href={isInfluencer && influencerName ? immersiveScenarioHref : scenarioHref}
      passHref
      legacyBehavior
    >
      <S.Wrapper data-testid="scenario">
        <S.ImageWrapper data-testid="recommendationCard">
          <S.TopWrapper>
            <S.Title ref={titleRef} $icon={iconUrl}>
              {title}
            </S.Title>
          </S.TopWrapper>
          <S.BottomWrapper>
            <div>{intl.formatMessage(msgs.scenarioLabel)}</div>
            <div>
              {numberOfLearnables} {intl.formatMessage(msgs.wordsOrPhrases)}
            </div>
          </S.BottomWrapper>
        </S.ImageWrapper>
      </S.Wrapper>
    </Link>
  );
};
